export const KBMAXPREFIX = '____kbm____';
export const LOCAL_ENVIRONMENT_DOMAIN = 'library://';
